import data from "../../../../../src/AvatarPair.docs.json";
import * as React from 'react';
export default {
  data,
  React
};